module.exports = "/_next/static/images/onnx-logo-1669be90a3970e20a968788658f3661a.png";